import { createAction } from '@reduxjs/toolkit';

export const shopperExperiencesHeaderActions = {
  navigateTo: createAction<{ navigateTo: string }>('ShopperExperiencesHeader/NavigateTo'),
};
